<template>
  <div
    class="errorPopupContainer flexContainer centerContainer columnContainer"
  >
    <p class="bigText">Spokojnie!</p>
    <p class="mediumText">{{ message }}</p>
    <button
      class="linkAlike bigText"
      style="align-self: center; color: #ec783e"
      @click="closePopup"
    >
      Wspaniale!
    </button>
  </div>
</template>

<script>
export default {
  props: {
    popupData: Object,
  },
  data() {
    return {
      message: null,
    };
  },
  methods: {
    closePopup() {
      this.$store.dispatch("deletePopupMessage");
    },
  },
  created() {
    if (this.popupData.status === 413) {
      this.message =
        "Zaplecze Wademekum jest małe – ten plik się nie zmieści. Zmieści się inny, poniżej 2MB.";
    } else {
      this.message =
        "Coś tu nie działa. Może kiedyś to naprawimy. Może nie. Nie wiadomo.";
    }
  },
};
</script>

<style scoped>
.errorPopupContainer {
  width: 25%;
  height: 25%;
  margin-top: 15%;
  margin-left: 26%;
  border: 2px solid red;
  background-color: #ffffff;
  justify-content: space-between;
  padding: 0.5%;
  box-shadow: 0 0 0 4px #ffffff, 0 0 0 6px #000000;
}

p {
  line-height: 25px;
  margin: 2%;
}

@media (max-width: 1000px) {
  .errorPopupContainer {
    margin-top: 53%;
    margin-left: 6%;
    width: 75%;
    height: 40%;
  }
}
</style>
